<template>
  <ElCard ref="hot" class="hot-user">
    <div class="title">近期活跃客户</div>
    <section ref="main" class="hot-echarts"></section>
  </ElCard>
</template>

<script>
import _ from 'lodash';
import echarts from 'echarts';
import {http, catchAppError} from '@/util';
import url from '@/config';

export default {
  name: 'HotUser',
  data() {
    return {
      hotuser: []
    };
  },
  watch: {
    hotuser() {
      this.initEachrt();
    }
  },
  async beforeMount() {
    await this._timeInterval();
  },
  methods: {
    async _timeInterval() {
      await this._getData();
      setTimeout(() => {
        this._timeInterval();
      }, 60000 * 5);
    },

    _getData() {
      http
        .post(url.hotUser)
        .then(res => {
          this.hotuser = res.splice(0, 7);
        })
        .catch(catchAppError);
    },

    initEachrt() {
      this.$refs.main.style.width = `${this.$refs.hot.clientWidth}px`;
      const myChart = echarts.init(this.$refs.main);
      const backgroundBar = _.fill(
        Array(this.hotuser.length),
        _.max(this.hotuser.map(res => res.num))
      );
      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{b1}: {c1}'
        },
        grid: {bottom: 20, top: 10},
        xAxis: {
          type: 'category',
          data: this.hotuser.map(res => res.user),
          axisLabel: {
            interval: 0,
            align: 'center',
            fontSize: 10
          }
        },
        yAxis: {
          type: 'value',
          splitLine: false
        },
        series: [
          {
            data: backgroundBar,
            itemStyle: {
              normal: {
                color: '#f2f5fc',
                barBorderRadius: 20
              }
            },
            barGap: '-100%',
            barWidth: '20px',
            barMaxWidth: '20px',
            type: 'bar'
          },
          {
            name: 'user',
            data: this.hotuser.map(res => res.num),
            itemStyle: {
              normal: {
                color: '#4b90ff',
                barBorderRadius: 20
              }
            },
            barWidth: '20px',
            barMaxWidth: '20px',
            type: 'bar'
          }
        ]
      };
      myChart.setOption(option);
    }
  }
};
</script>

<style lang="scss">
.hot-user {
  .el-card__body {
    padding: 0;
    height: 220px;
  }
  .title {
    text-align: center;
    padding-top: 18px;
    font-size: 16px;
  }
  .hot-echarts {
    height: 130px;
    padding-bottom: 20px;
    padding-top: 10px;
  }
}
</style>
